import { Registers } from '@factorin/domain';

import { withUrl, ItemRequest, patch, list } from '../rest';
import { RegisterListRequest } from './registers';


const discountRegistersPart = withUrl('discountregisters');

export const discountRegisters = {
    ...list<Registers.RegisterDetails, RegisterListRequest, Registers.Register>(
        discountRegistersPart(),
    ),
    cancel: patch<ItemRequest, void>(
        ({ id }) => discountRegistersPart({
            path: `${id}/cancel`,
        }),
    ),
};
